import { AreaChart as RechartsAreaChart, Area as RechartsArea } from 'recharts';

import { getColor, getOpagueColor } from '@nxs/utils';
import { IGenericChartProps } from './models';

export function AreaChart<T>(props: IGenericChartProps<T>) {

    const {
        data,
        width,
        height,
        children,
        dataKeys,
        disabledKeys
    } = props;

    return (
        <RechartsAreaChart
            data={data}
            width={width}
            height={height}
            className='chart'
            margin={{ left: -20 }}
        >
            {children}
            {
                dataKeys
                    .filter(x => disabledKeys.indexOf(x.dataKey) < 0)
                    .map(dataKey => (
                        <RechartsArea
                            key={dataKey.dataKey as any}
                            type="monotone"
                            name={dataKey.legendName}
                            dataKey={dataKey.dataKey as any}
                            stroke={getColor(dataKey.color)}
                            fill={getOpagueColor(dataKey.color, 0.7)}
                            activeDot={{ r: 3 }}
                            id={dataKey.dataKey as any}
                            stackId={dataKey.stackKey}
                            animationDuration={500}
                            animationBegin={0}
                        />
                    ))
            }
        </RechartsAreaChart>
    )
};